import { Backdrop, CircularProgress, Portal } from "@mui/material";
import type { FC } from "react";

export interface FullScreenLoaderProps {
  open?: boolean;
  zIndex?: number;
}

export const FullScreenLoader: FC<FullScreenLoaderProps> = ({
  open = true,
  zIndex = 1300,
}) => {
  return (
    <Portal>
      <Backdrop open={open} sx={{ color: "#fff", zIndex }}>
        <CircularProgress color="inherit"></CircularProgress>
      </Backdrop>
    </Portal>
  );
};
